<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <!-- Top left cross star -->
    <path
      d="M4.5 7V2M2 4.5h5"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
      class="dart-star-top-left" />
    <!-- Bottom left cross star -->
    <path
      d="M4.5 22v-5M2 19.5h5"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
      class="dart-star-bottom-left" />
    <!-- Large star -->
    <path
      d="M13 3l-1.734 4.509c-.282.733-.423 1.1-.643 1.408a3 3 0 0 1-.706.707c-.308.219-.675.36-1.408.642L4 12l4.509 1.734c.733.282 1.1.423 1.408.643.273.194.512.433.707.706.219.308.36.675.642 1.408L13 21l1.734-4.509c.282-.733.423-1.1.643-1.408.194-.273.433-.512.706-.707.308-.219.675-.36 1.408-.642L22 12l-4.509-1.734c-.733-.282-1.1-.423-1.408-.642a3 3 0 0 1-.706-.707c-.22-.308-.36-.675-.643-1.408L13 3Z"
      stroke="currentColor"
      fill="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
      class="dart-star-main" />
  </svg>
</template>

<style scoped>
@keyframes pulse-opacity-top-left {
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
}

@keyframes pulse-opacity-bottom-left {
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0.2;
  }
}

@keyframes pulse-opacity-main {
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0.7;
  }
}

.group\/animate-ai:hover .dart-star-top-left {
  animation: pulse-opacity-top-left 2s ease-in-out infinite;
}

.group\/animate-ai:hover .dart-star-bottom-left {
  animation: pulse-opacity-bottom-left 5s ease-in-out infinite;
}

.group\/animate-ai:hover .dart-star-main {
  animation: pulse-opacity-main 3s ease-in-out infinite;
}
</style>
